/*global jQuery:false */
/*global detectFeatures:false */
/*global _:false */

//Use to detect language on any page
if ($('html').attr('lang')) {
    var lang_generic = $('html').attr('lang').split('-');
    var lang = lang_generic[0];
}

// Global var
//let linkInternalPositionModifier = '';

jQuery(document).ready(function () {
	'use strict';

    //Adjust sticky main menu height
    const stickyMenuHeight = function () {
        $('.jean-coutu-menu').css('height', ($('.mm__container').innerHeight()));
    }
    stickyMenuHeight();
    $(window).on('resize', _.throttle(stickyMenuHeight, 500));

    // Tabs default
    // DEPRECATED use DISHIDE instead//
    $('[data-feature="tabs--default"]').tabs_default();

	// Wait 200ms. Waiting that all JS affecting layout are done.
	setTimeout(function(){
		$('[data-module~="stickyState"]').stickyState();
	}, 200);

    LoginEvents.lookup();

    $('.search__overlay .close--btn').on('click', function() {
        $('.search__overlay').hide();
        $('.search__overlay-container #header--search--input').val('');
    });

    $('[data-input-clear=""]').click( function () {
        manageEraseButton($(this));
    });
});

function manageSearchButtonWithEraseButton($inputSearch) {
    var $parentForm = $inputSearch.closest('form, .form');
    var $buttonClose = $parentForm.find('.input-close');
    if ($buttonClose.length) {
        if ($inputSearch.val() !== '') {
            $buttonClose.removeClass('field_is_empty');
        } else {
            $buttonClose.addClass('field_is_empty');
        }
    }
}

function manageEraseButton($eraseButton) {
    var parentForm = $eraseButton.closest('form, .form');
    $(parentForm).find('input[type=search]').val('');
    $(parentForm).find('.input-close').addClass('field_is_empty');
    $(parentForm).find('input[type=search]').focus();
}

// Must be on all pages
$('input[type=search]').keyup( function () {
    manageSearchButtonWithEraseButton($(this));
});
